import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AppLayout from "@/pages/AppLayout";
import Dashboard from "@/pages/Dashboard";
import InputForm from "@/pages/InputForm";
import DataPage from "@/pages/DataPage";
import MeetingForm from "@/pages/MeetingForm";
import WtrSi from "@/pages/WtrSi";
import Schedule from "@/pages/Schedule";
import StockAA from "@/pages/StockAA";
import PrintDailyReport from "@/pages/PrintDailyReport";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/print/daily/:tanggal" element={<ProtectedRoute><PrintDailyReport /></ProtectedRoute>} />
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="input" element={<ProtectedRoute><InputForm /></ProtectedRoute>} />
          <Route path="input/:id" element={<ProtectedRoute><InputForm /></ProtectedRoute>} />
          <Route path="meeting" element={<ProtectedRoute><MeetingForm /></ProtectedRoute>} />
          <Route path="data" element={<ProtectedRoute><DataPage /></ProtectedRoute>} />
          <Route path="stock-aa" element={<ProtectedRoute><StockAA /></ProtectedRoute>} />
          <Route path="wtr-si" element={<WtrSi />} />
          <Route path="schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppRoutes />
        <Toaster richColors position="top-right" />
      </div>
    </AuthProvider>
  );
}

export default App;
